import {
  ADMIN_BRAND_V_DRIVE_ASSIGNMENT_STRATEGY,
  ADMIN_LOCATIONS_V_DRIVE_ASSIGNMENT_STRATEGY,
  ArrowRed,
  Disclaimer,
  Div,
  Icon,
  Pill,
  SubTitleWithTooltipIcon,
  lightTheme,
  replaceRouteParams,
} from '@vgrubs/components';
import { useNavigate } from 'react-router-dom';

export const AssignmentStrategyComponent = ({
  isCustomized,
  id,
  isBrand,
  brandName,
}: {
  isCustomized: boolean;
  id: string;
  isBrand?: boolean;
  brandName?: string;
}) => {
  const navigate = useNavigate();

  const path = isBrand
    ? ADMIN_BRAND_V_DRIVE_ASSIGNMENT_STRATEGY
    : ADMIN_LOCATIONS_V_DRIVE_ASSIGNMENT_STRATEGY;

  return (
    <Div
      $pointer
      $flex
      $alignCenter
      $between
      $box
      $p="24px"
      $gap="16px"
      onClick={() =>
        navigate(
          replaceRouteParams(path, {
            id,
          }),
          {
            state: { name: brandName },
          }
        )
      }
    >
      <Div $width="100%" $pointer>
        <SubTitleWithTooltipIcon
          mb="0"
          text={'Delivery Assignment Strategy'}
          tooltip={
            'Customize how deliveries are assigned: choose which fleets handle orders depending on source (Uber, DoorDash, etc.), distance from the restaurant, or delivery zone. For example, route short city-center orders to MotoClick while sending longer trips to Uber Direct.'
          }
        />
      </Div>

      <Div $flex $alignCenter $gap="24px" $gapSM="16px">
        {isCustomized && (
          <Pill $background={lightTheme.primary}>
            <Disclaimer $m="0" $color={lightTheme.white}>
              Customized
            </Disclaimer>
          </Pill>
        )}
        <Icon $pointer>
          <ArrowRed />
        </Icon>
      </Div>
    </Div>
  );
};
